// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1MokY","list":"BalanceDue_list__2ZAz2","listRow":"BalanceDue_listRow__1XMQf","total":"BalanceDue_total__zFjWD"};